<div class="modal-header">
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
      </button>
  <h4 class="modal-title text-danger" id="modal-basic-title">Message</h4>
 
</div>
<div class="modal-body">

   <p [innerHTML]="strText"></p>
 
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="closeModal()">close</button>
</div>